var app = angular.module('leonardo');

var ContactTypeRestService = function(BaseRestService) {
  return new BaseRestService('contact-types');
};

app.factory('ContactTypeRestService', ['BaseRestService', ContactTypeRestService]);
